import { createContext, useContext, useState, useEffect } from 'react';

const ArbitroContext = createContext(null);

export function ArbitroProvider({ children }) {

  // Carga desde localStorage al iniciar
  const [arbitros, setArbitros] = useState(() => {
    try {
      const guardados = localStorage.getItem('turival_arbitros');
      return guardados ? JSON.parse(guardados) : [];
    } catch {
      return [];
    }
  });

  // Guarda en localStorage cada vez que cambia
  useEffect(() => {
    localStorage.setItem('turival_arbitros', JSON.stringify(arbitros));
  }, [arbitros]);

  const registrarArbitro = (datosArbitro) => {
    const nuevo = {
      ...datosArbitro,
      id: Date.now(),
      rating: 0,
      partidos: 0,
      iniciales: datosArbitro.nombre
        .split(' ')
        .filter(p => p.length > 0)
        .slice(0, 2)
        .map(p => p[0].toUpperCase())
        .join(''),
    };
    setArbitros(prev => [...prev, nuevo]);
    return nuevo;
  };

  return (
    <ArbitroContext.Provider value={{ arbitros, registrarArbitro }}>
      {children}
    </ArbitroContext.Provider>
  );
}

export function useArbitro() {
  return useContext(ArbitroContext);
}